import ItemView from "../../components/ItemView/ItemView.vue"
import { flightHours } from "./attachables";
export default [{
    "path": "/FlightHours",
    "component": { ...ItemView },
    "name": "Flight Hours",
    "meta": {
        "app": "ftc",
        "name": "Flight Hours",
        "sideNav": true,
        "sideNavSection": "Pilot Data",
        "tableSettings": "Flight Hours",
        "hideBackButton": true,
        title() {
            return `Flight Hours`;
        },
        "dataFields": [{
            "label": "Total Flight Hours",
            compute({ item }) {
                return Object.values(item?.raw?.NewFlightHours || {}).reduce((a, b) => {
                    return a + parseInt(b.Hours || 0);
                }, 0);
            }
        }],
        "menuActions": [],
        "attachedItems": {
            "Flight Hours": {
                "attachables": [ flightHours ]
            }
        },
        lock(user) {
            return [user?.Role !== "Pilot", "Only pilots can view this area"];
        }
    }
}];
